<template>
    <span
        class="icon button is-white"
        :class="[
            (urlIsFavourite ? 'fav-star-active' : 'fav-star-inactive'),
            (locked ? 'is-loading' : '')
        ]"
        :title="iconTooltip"
        @click="clickHandler()">
        <i class="mdi mdi-star" />
    </span>
</template>

<script>
    import favouriteService from '../../shared/services/favouriteService.ts';

    const tblFavouriteUrlLength = 2000;

    export default {
        data() {
            return {
                urlIsFavourite: false,
                favouriteId: undefined,
                locked: true
            };
        },
        computed: {
            url() {
                return window.location.pathname + window.location.search + window.location.hash;
            },
            title() {
                return window.document.title;
            },
            iconTooltip() {
                return this.urlIsFavourite ? 'Favourite page' : 'Make page favourite';
            }
        },
        watch: {
            async url() {
                await this.loadState();
            }
        },
        async mounted() {
            await this.loadState();
        },
        methods: {
            async loadState() {
                try {
                    this.locked = true;
                    [this.urlIsFavourite, this.favouriteId] = await favouriteService.lookup(this, this.url);
                } finally {
                    this.locked = false;
                }
            },
            async clickHandler() {
                if (this.locked) {
                    /* Operation already in progress, abort! */
                    return;
                }
                try {
                    this.locked = true;
                    if (this.urlIsFavourite) {
                        await favouriteService.remove(this, this.favouriteId);
                        this.favouriteId = undefined;
                        this.urlIsFavourite = false;
                        await window.headerMailbox.send('update-favourites');
                    } else if (this.url.length > tblFavouriteUrlLength) {
                        this.$buefy.dialog.alert({
                            title: 'Unable to add to favourites!',
                            message: 'The URL is too long and can not be used as a favourite. Consider using a browser bookmark instead.',
                            type: 'is-danger',
                            hasIcon: true
                        });
                    } else {
                        const self = this;
                        this.$buefy.dialog.prompt({
                            message: 'Save favourite..',
                            inputAttrs: {
                                minlength: 1,
                                maxlength: 256,
                                required: true,
                                value: favouriteService.stripPostfix(self.title)
                            },
                            onConfirm: async value => {
                                await favouriteService.add(this, value, this.url);
                                await this.loadState();
                                await window.headerMailbox.send('update-favourites');
                            }
                        });
                    }
                } finally {
                    this.locked = false;
                }
            }
        }
    };
</script>

<style>
</style>
